var AssigneesComponentModule = /** @class */ (function () {
    function AssigneesComponentModule() {
    }
    return AssigneesComponentModule;
}());
export { AssigneesComponentModule };
